<template>
    <div id="description" class="">
        <div class="mb-5">
            <h2 class="mb-5">Betaling</h2>
            <div :class="{ 'text-center': $store.getters.isSmall }">
                <button :class="['btn btn-outline-azure-dark mb-5']" @click="downloadInvoice">
                    <h2 class="m-0"><font-awesome-icon icon="file-invoice" class="mr-3" ></font-awesome-icon><span v-show="!$store.getters.isSmall">Download </span>Factuur</h2>
                </button>
            </div>
            <h2 :class="{ 'small': $store.getters.isSmall}">Factuurbedrag: € {{amount.toFixed(2)}}</h2>
            <h2 :class="{ 'small': $store.getters.isSmall }">
                <small :class="[toPay < 0 ? 'red' : 'text-muted']">Nog te ontvangen: € {{toPay.toFixed(2)}}</small>
            </h2>
            <hr>
            <h3 :class="['mt-5', { 'small': $store.getters.isSmall }]" >Voltooide Betalingen</h3>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead class="thead-azure-dark">
                        <tr>
                            <th>Datum</th>
                            <th>Bedrag</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="payments.length == 0">
                            <td colspan="2" class="text-center">
                                <loader width="3rem" v-if="isLoading"></loader>
                                <h4 class="text-muted mt-3" v-else>Nog geen betalingen ontvangen...</h4>
                            </td>
                        </tr>
                        <tr v-for="p in payments" :key="p.id" v-else>
                            <td>{{new Date(p.paymentDate).toLocaleDateString()}}</td>
                            <td>€ {{p.amount.toFixed(2)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader'
export default {
    components: {
        Loader
    },
    data() {
        return {
            isLoading: false,
            payments: [],
            amount: 0
        }
    },
    mounted() {
        this.getPayments();
        this.getAmount();
    },
    methods: {
        downloadInvoice() {
            this.$http.get('api/Invoice/Professional/' + this.$route.params.id, { responseType: 'blob' }).then((res) => 
            {
                let blob = new Blob([res.data], { type: res.headers.get('content-type') });

                let link = window.document.createElement("a");
                link.href = window.URL.createObjectURL(blob);

                link.download = "factuur.pdf";

                window.document.body.appendChild(link);

                link.click();

                window.document.body.removeChild(link);
            })
        },
        getAmount() {
            return this.$http.get('api/Invoice/Professional/Amount/' + this.$route.params.id).then((res) => {
                this.amount = res.data;
            })
        },
        getPayments() {
            this.isLoading = true;
            this.payments = [];
            return this.$http.get('api/Invoice/Professional/Payments/' + this.$route.params.id).then((res) => {
                if(res.data.length > 0)
                    this.payments = res.data;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            })
        }
    },
    computed: {
        toPay() {
            let sum = 0;
            this.payments.forEach((p) => { return sum += p.amount });
            return this.amount - sum;
        }
    }
}
</script>

<style scoped>